import { Link } from "react-router-dom";
import { brand, footer, nav, offices } from "@/content/site";
import { productLinks } from "@/content/products";
import { Logo } from "@/components/common/Logo";
import { OfficePartner } from "@/components/common/OfficePartner";
import { whatsappLink } from "@/lib/whatsapp";

const legal = [
  { label: "Privacy policy", to: "/privacy" },
  { label: "Terms of use", to: "/terms" },
];

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#0A1020] text-[#E8ECF2]" data-testid="site-footer">
    <div className="container-x relative z-10 pb-10 pt-20 lg:pt-28">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Link to="/" aria-label="SPC home" className="inline-block">
            <Logo variant="full" className="w-[260px] max-w-full" />
          </Link>
          <p className="mt-6 max-w-sm font-display text-2xl font-medium leading-snug tracking-[-0.02em] text-[#E8ECF2]">{footer.blurb}</p>
        </div>
        <nav className="lg:col-span-2" aria-label="Footer">
          <p className="mb-5 font-mono text-[12px] uppercase tracking-[0.14em] text-[#9AA6B8]">Explore</p>
          <ul className="space-y-3 text-[15px]">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="link-underline" data-testid={`footer-nav-${n.id}`}>
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mb-5 mt-10 font-mono text-[12px] uppercase tracking-[0.14em] text-[#9AA6B8]">Products</p>
          <ul className="space-y-3 text-[15px]">
            {productLinks.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="link-underline" data-testid={`footer-product-${p.to.split("/").pop()}`}>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="lg:col-span-3">
          <p className="mb-5 font-mono text-[12px] uppercase tracking-[0.14em] text-[#9AA6B8]">Offices</p>
          <ul className="space-y-5 text-[15px] [--accent:122_168_255]">
            {offices.map((o) => (
              <li key={o.id}>
                <p className="font-medium">{o.country}, {o.role}</p>
                <p className="mt-1 text-[#9AA6B8]">{o.address || o.city}</p>
                <OfficePartner office={o} className="mt-3 text-[#9AA6B8]" />
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="mb-5 font-mono text-[12px] uppercase tracking-[0.14em] text-[#9AA6B8]">Reach us</p>
          <ul className="space-y-3 text-[15px]">
            <li>
              <a href={`mailto:${brand.email}`} className="link-underline break-all" data-testid="footer-email-link">
                {brand.email}
              </a>
            </li>
            <li>
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="link-underline" data-testid="footer-whatsapp-link">
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 select-none font-display text-[22vw] font-semibold leading-[0.8] tracking-[-0.05em] text-[#E8ECF2]/[0.06] lg:text-[16rem]" aria-hidden="true">
        SPC
      </div>

      <div className="mt-6 border-t border-white/10 pt-8">
        <p className="max-w-3xl text-[13px] leading-relaxed text-[#9AA6B8]" data-testid="footer-disclaimer">
          {footer.disclaimer}
        </p>
        <div className="mt-6 flex flex-col gap-4 text-[13px] text-[#9AA6B8] sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} SPC. All rights reserved.</p>
          <ul className="flex gap-6">
            {legal.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="link-underline hover:text-[#E8ECF2]" data-testid={`footer-${l.to.slice(1)}-link`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </footer>
);
